<template>
    <div class="loading">
        <span></span>
        <span></span>
        <span></span>
    </div>
</template>

<script>
export default {
    name: 'iLoading'
}
</script>

<style lang="scss" scoped>
.loading {
    // width: 100px;
    height: 10px;
    margin: 20px auto;

    span {
        display: inline-block;
        width: 10px;
        height: 100%;
        margin-right: 5px;
        border-radius: 50%;
        background-color: #d8d8d8 !important;
        animation: loading 1s ease infinite;

        &:last-child {
            margin-right: 0;
        }

        &:nth-child(1) {
            animation-delay: 0.3s;
        }

        &:nth-child(2) {
            animation-delay: 0.6s;
        }

        &:nth-child(3) {
            animation-delay: 0.9s;
        }
    }
}

@keyframes loading {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/AirTicket/components/Loading.vue